document.addEventListener('DOMContentLoaded', () => {
  const slides = document.querySelectorAll('.tw-carousel-tables .tw-slide');

  const testimonialSwiper = new SwiperInitializer();

  const matchMedia = window.matchMedia('(min-width: 1280px)');

  const tables = document.querySelectorAll('[id^="comparison-table"]');

  if (!tables) {
    return;
  }
  matchMedia.addEventListener('change', (mediaQuery) => {
    if (!mediaQuery.matches) {
      testimonialSwiper.init(
        '[id^="comparison-table"]',
        {
          slidesPerView: 1,
          enabled:
            (matchMedia.matches && slides.length > 1) ||
            (!matchMedia.matches && slides.length > 1),
          spaceBetween: 16,
        },
        {
          paginationEl: '.swiper-pagination',
          pagination_type: 'bullets',
        },
      );
    } else {
      testimonialSwiper.destroySwipers();
    }
  });

  testimonialSwiper.init(
    '[id^="comparison-table"]',
    {
      slidesPerView: matchMedia.matches ? 1 : 'auto',
      enabled: !matchMedia.matches && slides.length > 1,
      spaceBetween: 16,
    },
    {
      paginationEl: '.swiper-pagination',
      pagination_type: 'bullets',
    },
  );
});
